export const country = [
  { idPnvt: 2, label: "Afghanistan", id: "AF" },
  { idPnvt: 3, label: "Albania", id: "AL" },
  { idPnvt: 4, label: "Algeria", id: "DZ" },
  { idPnvt: 5, label: "American Samoa", id: "AS" },
  { idPnvt: 6, label: "Andorra", id: "AD" },
  { idPnvt: 7, label: "Angola", id: "AO" },
  { idPnvt: 8, label: "Anguilla", id: "AI" },
  { idPnvt: 9, label: "Antarctica", id: "AQ" },
  { idPnvt: 10, label: "Antigua and Barbuda", id: "AG" },
  { idPnvt: 11, label: "Argentina", id: "AR" },
  { idPnvt: 12, label: "Armenia", id: "AM" },
  { idPnvt: 13, label: "Aruba", id: "AW" },
  { idPnvt: 250, label: "Ascension Island", id: "AC" },
  { idPnvt: 14, label: "Australia", id: "AU" },
  { idPnvt: 15, label: "Austria", id: "AT" },
  { idPnvt: 16, label: "Azerbaijan", id: "AZ" },
  { idPnvt: 17, label: "Bahamas", id: "BS" },
  { idPnvt: 18, label: "Bahrain", id: "BH" },
  { idPnvt: 19, label: "Bangladesh", id: "BD" },
  { idPnvt: 20, label: "Barbados", id: "BB" },
  { idPnvt: 21, label: "Belarus", id: "BY" },
  { idPnvt: 22, label: "Belgium", id: "BE" },
  { idPnvt: 23, label: "Belize", id: "BZ" },
  { idPnvt: 24, label: "Benin", id: "BJ" },
  { idPnvt: 25, label: "Bermuda", id: "BM" },
  { idPnvt: 26, label: "Bhutan", id: "BT" },
  { idPnvt: 27, label: "Bolivia (Plurinational State of)", id: "BO" },
  { idPnvt: 28, label: "Bonaire, Sint Eustatius and Saba", id: "BQ" },
  { idPnvt: 29, label: "Bosnia and Herzegovina", id: "BA" },
  { idPnvt: 30, label: "Botswana", id: "BW" },
  { idPnvt: 31, label: "Bouvet Island", id: "BV" },
  { idPnvt: 32, label: "Brazil", id: "BR" },
  { idPnvt: 33, label: "British Indian Ocean Territory", id: "IO" },
  { idPnvt: 34, label: "British Virgin Islands", id: "VG" },
  { idPnvt: 35, label: "Brunei Darussalam", id: "BN" },
  { idPnvt: 36, label: "Bulgaria", id: "BG" },
  { idPnvt: 37, label: "Burkina Faso", id: "BF" },
  { idPnvt: 38, label: "Burundi", id: "BI" },
  { idPnvt: 39, label: "Cabo Verde", id: "CV" },
  { idPnvt: 40, label: "Cambodia", id: "KH" },
  { idPnvt: 41, label: "Cameroon", id: "CM" },
  { idPnvt: 42, label: "Canada", id: "CA" },
  { idPnvt: 43, label: "Cayman Islands", id: "KY" },
  { idPnvt: 44, label: "Central African Republic", id: "CF" },
  { idPnvt: 251, label: "Ceuta & Melilla", id: "EA" },
  { idPnvt: 45, label: "Chad", id: "TD" },
  { idPnvt: 46, label: "Chile", id: "CL" },
  { idPnvt: 47, label: "China", id: "CN" },
  {
    idPnvt: 48,
    label: "China, Hong Kong Special Administrative Regio",
    id: "HK",
  },
  {
    idPnvt: 49,
    label: "China, Macao Special Administrative Region",
    id: "MO",
  },
  { idPnvt: 50, label: "Christmas Island", id: "CX" },
  { idPnvt: 51, label: "Cocos (Keeling) Islands", id: "CC" },
  { idPnvt: 52, label: "Colombia", id: "CO" },
  { idPnvt: 53, label: "Comoros", id: "KM" },
  { idPnvt: 54, label: "Congo", id: "CG" },
  { idPnvt: 55, label: "Cook Islands", id: "CK" },
  { idPnvt: 56, label: "Costa Rica", id: "CR" },
  { idPnvt: 57, label: "Croatia", id: "HR" },
  { idPnvt: 58, label: "Cuba", id: "CU" },
  { idPnvt: 59, label: "Curaçao", id: "CW" },
  { idPnvt: 60, label: "Cyprus", id: "CY" },
  { idPnvt: 61, label: "Czechia", id: "CZ" },
  { idPnvt: 62, label: "Côte d'Ivoire", id: "CI" },
  {
    idPnvt: 63,
    label: "Democratic People's Republic of Korea",
    id: "KP",
  },
  { idPnvt: 64, label: "Democratic Republic of the Congo", id: "CD" },
  { idPnvt: 65, label: "Denmark", id: "DK" },
  { idPnvt: 252, label: "Diego Garcia", id: "DG" },
  { idPnvt: 66, label: "Djibouti", id: "DJ" },
  { idPnvt: 67, label: "Dominica", id: "DM" },
  { idPnvt: 68, label: "Dominican Republic", id: "DO" },
  { idPnvt: 69, label: "Ecuador", id: "EC" },
  { idPnvt: 70, label: "Egypt", id: "EG" },
  { idPnvt: 71, label: "El Salvador", id: "SV" },
  { idPnvt: 72, label: "Equatorial Guinea", id: "GQ" },
  { idPnvt: 73, label: "Eritrea", id: "ER" },
  { idPnvt: 74, label: "Estonia", id: "EE" },
  { idPnvt: 75, label: "Ethiopia", id: "ET" },
  { idPnvt: 76, label: "Falkland Islands (Malvinas)", id: "FK" },
  { idPnvt: 77, label: "Faroe Islands", id: "FO" },
  { idPnvt: 78, label: "Fiji", id: "FJ" },
  { idPnvt: 79, label: "Finland", id: "FI" },
  { idPnvt: 80, label: "France", id: "FR" },
  { idPnvt: 81, label: "French Guiana", id: "GF" },
  { idPnvt: 82, label: "French Polynesia", id: "PF" },
  { idPnvt: 83, label: "French Southern Territories", id: "TF" },
  { idPnvt: 84, label: "Gabon", id: "GA" },
  { idPnvt: 85, label: "Gambia", id: "GM" },
  { idPnvt: 86, label: "Georgia", id: "GE" },
  { idPnvt: 87, label: "Germany", id: "DE" },
  { idPnvt: 88, label: "Ghana", id: "GH" },
  { idPnvt: 89, label: "Gibraltar", id: "GI" },
  { idPnvt: 90, label: "Greece", id: "GR" },
  { idPnvt: 91, label: "Greenland", id: "GL" },
  { idPnvt: 92, label: "Grenada", id: "GD" },
  { idPnvt: 93, label: "Guadeloupe", id: "GP" },
  { idPnvt: 94, label: "Guam", id: "GU" },
  { idPnvt: 95, label: "Guatemala", id: "GT" },
  { idPnvt: 96, label: "Guernsey", id: "GG" },
  { idPnvt: 97, label: "Guinea", id: "GN" },
  { idPnvt: 98, label: "Guinea-Bissau", id: "GW" },
  { idPnvt: 99, label: "Guyana", id: "GY" },
  { idPnvt: 100, label: "Haiti", id: "HT" },
  { idPnvt: 101, label: "Heard Island and McDonald Islands", id: "HM" },
  { idPnvt: 102, label: "Holy See", id: "VA" },
  { idPnvt: 103, label: "Honduras", id: "HN" },
  { idPnvt: 104, label: "Hungary", id: "HU" },
  { idPnvt: 105, label: "Iceland", id: "IS" },
  { idPnvt: 106, label: "India", id: "IN" },
  { idPnvt: 107, label: "Indonesia", id: "ID" },
  { idPnvt: 108, label: "Iran (Islamic Republic of)", id: "IR" },
  { idPnvt: 109, label: "Iraq", id: "IQ" },
  { idPnvt: 110, label: "Ireland", id: "IE" },
  { idPnvt: 111, label: "Isle of Man", id: "IM" },
  { idPnvt: 112, label: "Israel", id: "IL" },
  { idPnvt: 113, label: "Italy", id: "IT" },
  { idPnvt: 114, label: "Jamaica", id: "JM" },
  { idPnvt: 115, label: "Japan", id: "JP" },
  { idPnvt: 116, label: "Jersey", id: "JE" },
  { idPnvt: 117, label: "Jordan", id: "JO" },
  { idPnvt: 118, label: "Kazakhstan", id: "KZ" },
  { idPnvt: 119, label: "Kenya", id: "KE" },
  { idPnvt: 120, label: "Kiribati", id: "KI" },
  { idPnvt: 253, label: "Kosovo", id: "XK" },
  { idPnvt: 121, label: "Kuwait", id: "KW" },
  { idPnvt: 122, label: "Kyrgyzstan", id: "KG" },
  { idPnvt: 123, label: "Lao People's Democratic Republic", id: "LA" },
  { idPnvt: 124, label: "Latvia", id: "LV" },
  { idPnvt: 125, label: "Lebanon", id: "LB" },
  { idPnvt: 126, label: "Lesotho", id: "LS" },
  { idPnvt: 127, label: "Liberia", id: "LR" },
  { idPnvt: 128, label: "Libya", id: "LY" },
  { idPnvt: 129, label: "Liechtenstein", id: "LI" },
  { idPnvt: 130, label: "Lithuania", id: "LT" },
  { idPnvt: 131, label: "Luxembourg", id: "LU" },
  { idPnvt: 132, label: "Madagascar", id: "MG" },
  { idPnvt: 133, label: "Malawi", id: "MW" },
  { idPnvt: 134, label: "Malaysia", id: "MY" },
  { idPnvt: 135, label: "Maldives", id: "MV" },
  { idPnvt: 136, label: "Mali", id: "ML" },
  { idPnvt: 137, label: "Malta", id: "MT" },
  { idPnvt: 138, label: "Marshall Islands", id: "MH" },
  { idPnvt: 139, label: "Martinique", id: "MQ" },
  { idPnvt: 140, label: "Mauritania", id: "MR" },
  { idPnvt: 141, label: "Mauritius", id: "MU" },
  { idPnvt: 142, label: "Mayotte", id: "YT" },
  { idPnvt: 143, label: "Mexico", id: "MX" },
  { idPnvt: 144, label: "Micronesia (Federated States of)", id: "FM" },
  { idPnvt: 145, label: "Monaco", id: "MC" },
  { idPnvt: 146, label: "Mongolia", id: "MN" },
  { idPnvt: 147, label: "Montenegro", id: "ME" },
  { idPnvt: 148, label: "Montserrat", id: "MS" },
  { idPnvt: 149, label: "Morocco", id: "MA" },
  { idPnvt: 150, label: "Mozambique", id: "MZ" },
  { idPnvt: 151, label: "Myanmar", id: "MM" },
  { idPnvt: 152, label: "Namibia", id: "NA" },
  { idPnvt: 153, label: "Nauru", id: "NR" },
  { idPnvt: 154, label: "Nepal", id: "NP" },
  { idPnvt: 155, label: "Netherlands", id: "NL" },
  { idPnvt: 156, label: "New Caledonia", id: "NC" },
  { idPnvt: 157, label: "New Zealand", id: "NZ" },
  { idPnvt: 158, label: "Nicaragua", id: "NI" },
  { idPnvt: 159, label: "Niger", id: "NE" },
  { idPnvt: 160, label: "Nigeria", id: "NG" },
  { idPnvt: 161, label: "Niue", id: "NU" },
  { idPnvt: 162, label: "Norfolk Island", id: "NF" },
  { idPnvt: 220, label: "North Macedonia", id: "MK" },
  { idPnvt: 163, label: "Northern Mariana Islands", id: "MP" },
  { idPnvt: 164, label: "Norway", id: "NO" },
  { idPnvt: 165, label: "Oman", id: "OM" },
  { idPnvt: 166, label: "Pakistan", id: "PK" },
  { idPnvt: 167, label: "Palau", id: "PW" },
  { idPnvt: 168, label: "Panama", id: "PA" },
  { idPnvt: 169, label: "Papua New Guinea", id: "PG" },
  { idPnvt: 170, label: "Paraguay", id: "PY" },
  { idPnvt: 171, label: "Peru", id: "PE" },
  { idPnvt: 172, label: "Philippines", id: "PH" },
  { idPnvt: 173, label: "Pitcairn", id: "PN" },
  { idPnvt: 174, label: "Poland", id: "PL" },
  { idPnvt: 175, label: "Portugal", id: "PT" },
  { idPnvt: 176, label: "Puerto Rico", id: "PR" },
  { idPnvt: 177, label: "Qatar", id: "QA" },
  { idPnvt: 178, label: "Republic of Korea", id: "KR" },
  { idPnvt: 179, label: "Republic of Moldova", id: "MD" },
  { idPnvt: 180, label: "Romania", id: "RO" },
  { idPnvt: 181, label: "Russian Federation", id: "RU" },
  { idPnvt: 182, label: "Rwanda", id: "RW" },
  { idPnvt: 183, label: "Réunion", id: "RE" },
  { idPnvt: 184, label: "Saint Barthélemy", id: "BL" },
  { idPnvt: 185, label: "Saint Helena", id: "SH" },
  { idPnvt: 186, label: "Saint Kitts and Nevis", id: "KN" },
  { idPnvt: 187, label: "Saint Lucia", id: "LC" },
  { idPnvt: 188, label: "Saint Martin (French Part)", id: "MF" },
  { idPnvt: 189, label: "Saint Pierre and Miquelon", id: "PM" },
  { idPnvt: 190, label: "Saint Vincent and the Grenadines", id: "VC" },
  { idPnvt: 191, label: "Samoa", id: "WS" },
  { idPnvt: 192, label: "San Marino", id: "SM" },
  { idPnvt: 193, label: "Sao Tome and Principe", id: "ST" },
  { idPnvt: 194, label: "Saudi Arabia", id: "SA" },
  { idPnvt: 195, label: "Senegal", id: "SN" },
  { idPnvt: 196, label: "Serbia", id: "RS" },
  { idPnvt: 197, label: "Seychelles", id: "SC" },
  { idPnvt: 198, label: "Sierra Leone", id: "SL" },
  { idPnvt: 199, label: "Singapore", id: "SG" },
  { idPnvt: 200, label: "Sint Maarten (Dutch part)", id: "SX" },
  { idPnvt: 201, label: "Slovakia", id: "SK" },
  { idPnvt: 202, label: "Slovenia", id: "SI" },
  { idPnvt: 203, label: "Solomon Islands", id: "SB" },
  { idPnvt: 204, label: "Somalia", id: "SO" },
  { idPnvt: 205, label: "South Africa", id: "ZA" },
  {
    idPnvt: 206,
    label: "South Georgia and the South Sandwich Islands",
    id: "GS",
  },
  { idPnvt: 207, label: "South Sudan", id: "SS" },
  { idPnvt: 208, label: "Spain", id: "ES" },
  { idPnvt: 209, label: "Sri Lanka", id: "LK" },
  { idPnvt: 210, label: "State of Palestine", id: "PS" },
  { idPnvt: 211, label: "Sudan", id: "SD" },
  { idPnvt: 212, label: "Suriname", id: "SR" },
  { idPnvt: 213, label: "Svalbard and Jan Mayen Islands", id: "SJ" },
  { idPnvt: 214, label: "Swaziland", id: "SZ" },
  { idPnvt: 215, label: "Sweden", id: "SE" },
  { idPnvt: 216, label: "Switzerland", id: "CH" },
  { idPnvt: 217, label: "Syrian Arab Republic", id: "SY" },
  { idPnvt: 1, label: "Taiwan", id: "TW" },
  { idPnvt: 218, label: "Tajikistan", id: "TJ" },
  { idPnvt: 219, label: "Thailand", id: "TH" },
  { idPnvt: 1021, label: "The Canarian islands", id: "IC" },
  { idPnvt: 221, label: "Timor-Leste", id: "TL" },
  { idPnvt: 222, label: "Togo", id: "TG" },
  { idPnvt: 223, label: "Tokelau", id: "TK" },
  { idPnvt: 224, label: "Tonga", id: "TO" },
  { idPnvt: 225, label: "Trinidad and Tobago", id: "TT" },
  { idPnvt: 256, label: "Tristan da Cunha", id: "TA" },
  { idPnvt: 226, label: "Tunisia", id: "TN" },
  { idPnvt: 227, label: "Turkey", id: "TR" },
  { idPnvt: 228, label: "Turkmenistan", id: "TM" },
  { idPnvt: 229, label: "Turks and Caicos Islands", id: "TC" },
  { idPnvt: 230, label: "Tuvalu", id: "TV" },
  { idPnvt: 231, label: "Uganda", id: "UG" },
  { idPnvt: 232, label: "Ukraine", id: "UA" },
  { idPnvt: 233, label: "United Arab Emirates", id: "AE" },
  {
    idPnvt: 234,
    label: "United Kingdom of Great Britain and Northern Irela",
    id: "GB",
  },
  { idPnvt: 235, label: "United Republic of Tanzania", id: "TZ" },
  {
    idPnvt: 236,
    label: "United States Minor Outlying Islands",
    id: "UM",
  },
  { idPnvt: 237, label: "United States Virgin Islands", id: "VI" },
  { idPnvt: 238, label: "United States of America", id: "US" },
  { idPnvt: 239, label: "Uruguay", id: "UY" },
  { idPnvt: 240, label: "Uzbekistan", id: "UZ" },
  { idPnvt: 241, label: "Vanuatu", id: "VU" },
  {
    idPnvt: 242,
    label: "Venezuela (Bolivarian Republic of Venezuela)",
    id: "VE",
  },
  { idPnvt: 243, label: "Viet Nam", id: "VN" },
  { idPnvt: 244, label: "Wallis and Futuna Islands", id: "WF" },
  { idPnvt: 245, label: "Western Sahara", id: "EH" },
  { idPnvt: 246, label: "Yemen", id: "YE" },
  { idPnvt: 247, label: "Zambia", id: "ZM" },
  { idPnvt: 248, label: "Zimbabwe", id: "ZW" },
  { idPnvt: 249, label: "Åland Islands", id: "AX" },
];
